import { VdsLink } from '@volt/volt-extended-components-react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ElementList from '@cas/components/tables/cells/element-list/ElementList';
import { refCallbackPreventPropagation } from '@cas/utils/vdsHelpers';
import { PartnerResourceFileType, PartnerResourceModel } from '@cas/config/documents';

export interface PartnerLinkValue {
  uri?: string;
  fileSize?: number;
  fileType?: PartnerResourceFileType;
}

export default function PartnerResourceLinkCellRenderer({
  value,
}: CustomCellRendererProps<PartnerResourceModel, PartnerLinkValue>): ReactElement | null {
  const { t } = useTranslation();

  if (value) {
    const { uri, fileSize: sizeBytes, fileType } = value;

    if (typeof uri !== 'undefined') {
      let label = t('Open');
      let icon = 'open-icon';

      if (fileType !== PartnerResourceFileType.Link && typeof sizeBytes !== 'undefined') {
        const megabytes = (sizeBytes / 1024 / 1024).toFixed(1);
        label = `${megabytes}MB`;
        icon = 'download';
      }

      return (
        <ElementList>
          <VdsLink
            value={label}
            underline={false}
            url={uri}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            variant="primary"
            iconPosition="left"
            informativeIcon={icon}
            ref={refCallbackPreventPropagation}
          />
        </ElementList>
      );
    }
  }

  return null;
}
